jQuery(document).ready(function(){
  	//jQuery( window ).load(function() {
  		//setTimeout(function(){
  			//jQuery('a.cd-faq-trigger:first-child').addClass('firstLi');
         // jQuery('a.cd-faq-trigger:first-child').next().find('.cd-faq-content').css("display","block !important");
		//}, 500);
    	
  	//});
	//jQuery(document).ready(function(){
        // Check for PO Box text in address fields on checkout
//         var $addresses = jQuery('#edit_checkout #checkout_shipping_address_address1"]')
//             .add($('#edit_checkout #checkout_shipping_address_city')),
//             message = "<div class='message hidden'><p>We <strong>don't ship to PO Boxes</strong>. Sorry for the inconvenience.</p></div>";
    
//         $addresses.after(message);
    
//         $addresses.keyup(function () {
//             var $value = jQuery(this).val();
    
//             if(/p\.?o/i.test($value)) { 
//                 jQuery(this).siblings('.message').removeClass('hidden');
//             } else if ($value === '') {
//                 jQuery(this).siblings('.message').addClass('hidden');
//             }
  //         });
    //});
  jQuery('.mega1-collumn1').find('ul li a').each(function(index) {
        var anchorTxt = jQuery(this).text();
    	jQuery(this).addClass(anchorTxt);
   });
  jQuery('.mega1-collumn2').find('ul li a').each(function(index) {
        var anchorTxt = jQuery(this).text();
    	jQuery(this).addClass(anchorTxt);
   });
  jQuery('.mega1-collumn3').find('ul li a').each(function(index) {
        var anchorTxt = jQuery(this).text();
    	jQuery(this).addClass(anchorTxt);
   });
  
//   Hide search modal on close button click
  document.querySelector('#lightbox-search button.close').addEventListener('click', function(){
    document.getElementById('lightbox-search').classList.remove('in');
  });

setTimeout(function() {

   // Show the first tab and hide the rest
jQuery('.faqs-list-items li:first-child').addClass('active');
jQuery('.cd-faq-group').hide();
jQuery('.cd-faq-group:first-child').show();


// Click function
jQuery('.faqs-list-items li').click(function(){
  jQuery('.faqs-list-items li').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.cd-faq-group').hide();
  
  var activeTab = jQuery(this).attr('href');
  jQuery(activeTab).fadeIn();
  return false;
});
},3000);

});